/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmployeeContractApiModel } from './employeeContractApiModel';
import { AddressApiModel } from './addressApiModel';


export interface EmployeeDetailApiModel { 
    id: number;
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    dateOfBirth: string;
    address: string;
    email: string;
    phoneNumber: string;
    birthNumber: string;
    personalNumber: string;
    active: boolean;
    contracts: Array<EmployeeContractApiModel>;
    addressDto: AddressApiModel;
    age: number;
}

